/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleManagementCategoryItemResponse } from './CarpsaleManagementCategoryItemResponse';

export type CarpsaleManagementCategoryItemResponseApiRespoonse = {
    data?: CarpsaleManagementCategoryItemResponse;
    status?: CarpsaleManagementCategoryItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleManagementCategoryItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

